import React, { useState, useEffect } from 'react';
import { Modal, Button, Box, Grid, TextField } from '@mui/material';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import AddAdvertisements from './AddAdvertisements/AddAdvertisements';
import AdvertisementService from '../../../services/advertisements';
import BodyAdvertisements from '../../components/Advertisements/BodyAdvertisements';
import { getDateOL } from '../../../utils/function';
import { CODES } from '../../../utils/responseCodes';
import SpinnerLoader from '../../components/general/SpinnerLoader';
import { Card, CardContent, Typography } from '@mui/material';
import { Toast } from "../../../utils/alerts";
const newAdvertisements = { "nombre": "", "nombreCorto": "", "nameFile": null, "file": null, }

const Advertisements = ({ }) => {
    const [isJefe, setIsJefe] = useState(false);
    const [titleModalLoader, setTitleModalLoader] = useState('');
    const [openModalLoader, setOpenModalLoader] = useState(true);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // Obtener el año y el mes actuales
    const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const [dateStart, setDateStart] = useState(getDateOL(firstDayOfMonth, 'short'));
    const [dateEnd, setDateEnd] = useState(getDateOL(lastDayOfMonth, 'short'));

    const [infoAdvertisement, setInfoAdvertisement] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [nombre, setNombre] = useState('');
    const [trabajador, setTrabajador] = useState('');
    const [dataAdvertisements, setDataAdvertisements] = useState(null);
    const [carpeta, setCarpeta] = useState(null);
    const [carpetaSeleccionada, setCarpetaSeleccionada] = useState(null);
    const [desCarpetaSel, setDesCarpetaSel] = useState(null);


    const [openCreateCarpeta, setOpenCreateCarpeta] = useState(false);
    const [nuevaCarpeta, setNuevaCarpeta] = useState('');

    useEffect(() => {
        getCarpeta(); getJefeCarpeta();getAdvertisements();
        // getAdvertisements();
    }, []);

    useEffect(() => {
        if ((!dateStart || dateStart === "") ||
            (!dateEnd || dateEnd === "")) {
            setDataAdvertisements([]);
            setTotalPages(1);
        }
    }, [dateStart, dateEnd])

    useEffect(() => {
        if (page && carpetaSeleccionada !== null) {
            getAdvertisements();
        }
    }, [page, carpetaSeleccionada]);

    const getAdvertisements = async () => {
        try {
            setOpenModalLoader(true);
            setTitleModalLoader("Buscando anuncios ...");

            setDataAdvertisements([]);
            setTotalPages(1);

            const result = await AdvertisementService.getAdvertisements({
                page: page,
                fechaIni: dateStart,
                fechaFin: dateEnd,
                nmbNormal_NmbCorto: nombre,
                trabajador: trabajador,
                carpetaArea_id: carpetaSeleccionada,
            });

            if (result.status === CODES.SUCCESS_200) {
                setTotalPages(result.data.last_page);
                setDataAdvertisements(result.data.data);
            }

            setOpenModalLoader(false);
            setTitleModalLoader("");
        } catch (error) {
            console.log(`Error en getAdvertisements: ${error}`);
        }
    };

    const handleOpenModal = (info) => {
        const mergedInfo = { ...newAdvertisements, ...info };
        handleOpen();
        setInfoAdvertisement(mergedInfo)
    }

    const getCarpeta = async () => {
        try {
            setOpenModalLoader(true);
            //  setTitleModalLoader("Buscando anuncios ...");

            setDataAdvertisements([]);
            setTotalPages(1);
            const result = await AdvertisementService.getCarpeta();
            if (result.status === CODES.SUCCESS_200) {
                setTotalPages(result.data.last_page)
                setCarpeta(result.data)
            }
            setOpenModalLoader(false);
            setTitleModalLoader("");
        } catch (error) {
            console.log(`Error en getCarpeta: ${error}`);
        }
    };

    const handleCarpetaClick = (id_carpetaArea, desCarpeta) => {
        setCarpetaSeleccionada(id_carpetaArea);
        setDesCarpetaSel(desCarpeta);
        setPage(1); // Esto desencadenará el useEffect de `page`
    };
    const saveCarpeta = async () => {
        if (!nuevaCarpeta.trim()) {
            Toast.fire({
                icon: "info",
                title: "Debe ingresar un nombre de carpeta.",
            });
            return;
        }
    
        setOpenModalLoader(true);
        setTitleModalLoader("Guardando ...");
    
        const formData = new FormData();
        formData.append("desCarpeta", nuevaCarpeta);
    
        try {
            const response = await AdvertisementService.saveCarpeta(formData);
    
            if (response.status === 201) {
                Toast.fire({
                    icon: "success",
                    title: response.data.message || "Carpeta creada correctamente",
                });
                setNuevaCarpeta('');
                setOpenCreateCarpeta(false);
                getCarpeta();
            } else {
                Toast.fire({
                    icon: "error",
                    title: "Error al crear la carpeta.",
                });
            }
        } catch (error) {
            console.error(error);
            Toast.fire({
                icon: "error",
                title: "Ocurrió un error inesperado.",
            });
        } finally {
            setOpenModalLoader(false);
            setTitleModalLoader("");
        }
    };
    

    const getJefeCarpeta = async () => {
        try {
            setOpenModalLoader(true);
            //  setTitleModalLoader("Buscando anuncios ...");
            const result = await AdvertisementService.getJefeCarpeta();
            if (result.status === CODES.SUCCESS_200) {
                setIsJefe(result.data)
            }
            setOpenModalLoader(false);
            setTitleModalLoader("");
        } catch (error) {
            console.log(`Error en getCarpeta: ${error}`);
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AddAdvertisements
                open={open}
                handleClose={handleClose}
                setTitleModalLoader={setTitleModalLoader}
                setOpenModalLoader={setOpenModalLoader}
                getAdvertisements={getAdvertisements}
                infoAdvertisement={infoAdvertisement}
                setInfoAdvertisement={setInfoAdvertisement}
                carpetaSeleccionada={carpetaSeleccionada}
            />
            <Modal open={openCreateCarpeta} onClose={() => setOpenCreateCarpeta(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                        width: 300,
                    }}
                >
                    <TextField
                        fullWidth
                        size="small"
                        label="Nombre de la carpeta"
                        value={nuevaCarpeta}
                        onChange={(e) => setNuevaCarpeta(e.target.value)}
                    />
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={saveCarpeta}
                        >
                            Guardar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid item xs={6} sm={6} md={2} display={'flex'} justifyContent={'center'}>
                    <div className='group' style={{ width: '100%' }} >
                        <div className="contenido">
                            <label className="label" style={{ fontSize: 'small', }}>Fecha Inicio</label>
                            <input type="date" className="input mt-1" aria-describedby="Fecha inicial"
                                style={{ border: 'solid 1px #D5DBDB', fontSize: 'small', }}
                                value={dateStart} onChange={(e) => setDateStart(e.target.value)}
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={6} sm={6} md={2} display={'flex'} justifyContent={'center'}>
                    <div className='group' style={{ width: '100%' }} >
                        <div className="contenido">
                            <label className="label" style={{ fontSize: 'small', }}>Fecha Fin</label>
                            <input type="date" className="input mt-1" aria-describedby="Fecha final"
                                style={{ border: 'solid 1px #D5DBDB', fontSize: 'small', }}
                                value={dateEnd} onChange={(e) => setDateEnd(e.target.value)}
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={2} display={'flex'} justifyContent={'center'}>
                    <div className="group" style={{ width: '100%' }}>
                        <div className="contenido">
                            <TextField
                                variant="outlined"
                                label="Nombre del trabajador"
                                size='small'
                                sx={{ paddingBottom: 1 }}
                                onChange={(e) => setTrabajador(e.target.value)}
                                fullWidth
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={2} display={'flex'} justifyContent={'center'}>
                    <div className="group" style={{ width: '100%' }}>
                        <div className="contenido" >
                            <TextField
                                variant="outlined"
                                label="Nombre del anuncio"
                                size='small'
                                sx={{ paddingBottom: 1 }}
                                onChange={(e) => setNombre(e.target.value)}
                                fullWidth
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={6} sm={6} md={1} display={'flex'} justifyContent={'flex-start'} gap={1}>
                    <button
                        onClick={() => {
                            if (carpetaSeleccionada) {
                                handleOpenModal();
                            } else {
                                alert('Debe seleccionar una carpeta primero.');
                            }
                        }}
                        className='btn btn-outline-success btn-sm'
                        disabled={!carpetaSeleccionada}
                    >
                        <AddToPhotosIcon />
                    </button>
                    <button
                        style={{ width: '100%' }}
                        onClick={getAdvertisements}
                        className='btn btn-outline-dark btn-sm'
                    >
                        Buscar
                    </button>
                </Grid>
            </Grid>
            <Grid container
                direction="row"
                justifyContent="center"
                alignItems="center"
                mt={2}
            >
                <Grid item xs={10} sm={9}>
                    <Box
                        sx={{
                            overflowX: 'auto',
                            width: '100%',
                            mb: 2,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: 'fit-content',
                                margin: '0 auto',
                                gap: 2,
                                paddingX: 2,
                            }}
                        >
                            {carpeta && carpeta.length > 0 &&
                                carpeta.map((item) => (
                                    <Card
                                        key={item.id_carpetaArea}
                                        sx={{
                                            minWidth: 140,
                                            textAlign: 'center',
                                            padding: 1,
                                            backgroundColor: carpetaSeleccionada === item.id_carpetaArea ? '#e3f2fd' : 'inherit',
                                            cursor: 'pointer',
                                            border: carpetaSeleccionada === item.id_carpetaArea ? '1px solid #1976d2' : '1px solid #ccc',
                                            flexShrink: 0,
                                        }}
                                        onClick={() => handleCarpetaClick(item.id_carpetaArea, item.desCarpeta)}
                                    >
                                        <CardContent>
                                            {carpetaSeleccionada === item.id_carpetaArea ? (
                                                <FolderOpenIcon style={{ fontSize: 40, color: '#1976d2' }} />
                                            ) : (
                                                <FolderIcon style={{ fontSize: 40, color: '#5E5E5DFF' }} />
                                            )}
                                            <Typography variant="body2">{item.desCarpeta}</Typography>
                                        </CardContent>
                                    </Card>
                                ))
                            }

                            {isJefe.isJefe && (
                                <Card
                                    sx={{
                                        minWidth: 140,
                                        textAlign: 'center',
                                        padding: 1,
                                        cursor: 'pointer',
                                        border: '1px dashed #ccc',
                                        flexShrink: 0,
                                        backgroundColor: '#f0f0f0',
                                    }}
                                    onClick={() => setOpenCreateCarpeta(true)}
                                >
                                    <CardContent>
                                        <AddToPhotosIcon style={{ fontSize: 40, color: '#1976d2' }} />
                                        <Typography variant="body2">Nueva Carpeta</Typography>
                                    </CardContent>
                                </Card>
                            )}
                        </Box>
                    </Box>
                    <BodyAdvertisements
                        setTitleModalLoader={setTitleModalLoader}
                        open={openModalLoader}
                        setOpenModalLoader={setOpenModalLoader}
                        records={dataAdvertisements}
                        handleOpenModal={handleOpenModal}
                        getAdvertisements={getAdvertisements}
                        totalPages={totalPages}
                        page={page}
                        setPage={setPage} desCarpetaSel={desCarpetaSel}
                        isJefe={isJefe} carpetaSeleccionada={carpetaSeleccionada}
                    />
                </Grid>
            </Grid>
            <SpinnerLoader open={openModalLoader} title={titleModalLoader} />
        </Box>
    );
};

export default Advertisements;